import InfoBarViewState from 'owa-info-bar/lib/schema/InfoBarViewState';

export default function hasCharmlessInfoBars(infoBarViewState: InfoBarViewState): boolean {
    let hasCharmless = false;
    const messages = infoBarViewState ? infoBarViewState.messages : [];

    for (let idx = 0; idx < messages.length; idx++) {
        const key = messages[idx].key;
        if (
            key == 'unsubscribeInfoBar' ||
            key == 'safetyBar' ||
            key == 'infoSensitivity' ||
            key == 'irmInfoBar' ||
            key == 'infoMessageSubmitted' ||
            key == 'agendaMailFeedback'
        ) {
            hasCharmless = true;
            break;
        }
    }

    return hasCharmless;
}
